// extracted by mini-css-extract-plugin
export default {"icon":"styles_icon__ghpAD","sm":"styles_sm__yrBwB","md":"styles_md__NqCOg","lg":"styles_lg__ppCZI"};